export enum ECycleDirection {
  CD_Forward,
  CD_Backward,
}
